import { render, staticRenderFns } from "./TodoItems.vue?vue&type=template&id=5f6896c2&"
import script from "./TodoItems.vue?vue&type=script&lang=js&"
export * from "./TodoItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports